export default __webpack_public_path__ + "static/media/Layer 3.cc201201.jpg";